/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 获取本地配置文件
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-16 22:59:22
 * @LastEditTime: 2022-11-17 10:44:10
 * @FilePath: /client-h5-v2/src/apis/config/applicationPropterty.ts
 */
import axios from 'axios'

// 获取用户信息
export function apiGetApplicationPropterty (configFileName: string) {
  return axios.get(`/${window.botV2GlobalProperties.BASE_PATH}/json/application-properties/${configFileName}-application-properties.json`)
}

export function apiGetCommonMaping () {
  return axios.get(`/${window.botV2GlobalProperties.BASE_PATH}/json/common/maping.json`)
}

export function apiGetLocalfiles (url: string) {
  // 普通web(pc、mobile)模式
  return axios.get(url)
  // return httpRequest({
  //   url: url,
  //   method: 'get'
  // })
}
